import React from "react";

const featuredClients = [
  {
    id: "clickup",
    name: "Clickup",
    logo: "/Logo/recent-clients/clickup.png",
    description:
      "Delivered video editing and graphic design support to create engaging and consistent brand content.",
  },
  {
    id: "boxsy",
    name: "Boxsy",
    logo: "/Logo/recent-clients/boxsy.png",
    description:
      "Redesigned the entire website to align with their tone of voice and improve clarity and structure.",
  },
  {
    id: "enclaim",
    name: "Enclaim",
    logo: "/Logo/recent-clients/enclaim.png",
    description:
      "Redesigned user flows and interface while developing a new franchise application to enhance usability.",
  },
];

const RecentClients = () => {
  return (
    <section
      className="relative py-16 md:py-20 overflow-hidden"
      style={{
        backgroundImage: "url('/assets/svg/plain_dot.svg')",
      }}
    >
      <img
        src="/assets/png/Ellipse_left.png"
        alt=""
        aria-hidden="true"
        className="absolute top-0 left-0 pointer-events-none select-none"
      />
      <img
        src="/assets/png/Ellipse_right.png"
        alt=""
        aria-hidden="true"
        className="absolute bottom-0 right-0 pointer-events-none select-none"
      />

      <div className="container mx-auto px-4 md:px-12 relative z-10">
        {/* Heading */}
        <div className="flex flex-col items-center text-center mb-10 md:mb-14">
          <h2 className="text-4xl md:text-6xl font-medium text-[#1E1A1C] font-inter leading-tight">
            Our Recent Clients
          </h2>
          <p className="text-[#363435] text-base md:text-xl mt-4 font-lexend font-light leading-7 max-w-2xl">
            Proud partners in delivering thoughtful design solutions for modern
            and growing brands.
          </p>
        </div>

        {/* 3 Featured Client Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          {featuredClients.map((client) => (
            <div
              key={client.id}
              className="bg-white/70 backdrop-blur-sm border border-gray-200 rounded-2xl p-8 flex flex-col items-center text-center shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="h-20 flex items-center justify-center mb-6 w-full">
                <img
                  src={client.logo}
                  alt={`${client.name} logo`}
                  className="max-h-16 w-auto max-w-full object-contain"
                />
              </div>
              <h3 className="text-xl md:text-2xl font-medium text-[#1E1A1C] font-inter mb-3">
                {client.name}
              </h3>
              <p className="text-sm md:text-base text-[#363435] font-lexend font-light leading-6">
                {client.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentClients;
